import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";

export const GUIDE_STEPS = [
  { n: 1, title: "Log in", body: "Your username is your first name and your password is your surname (your teacher will confirm your exact details). On a phone, tap 'Add to Home Screen' to use it like an app." },
  { n: 2, title: "Choose what to revise", body: "On your dashboard, tap 'Revise all due today' for everything scheduled, or open a course → topic → deck under 'Revise by topic' to focus on one area. Both count as real revision." },
  { n: 3, title: "Study each card", body: "Read the question, tap 'Show answer', then rate yourself honestly: Again, Hard, Good or Easy." },
  { n: 4, title: "Let the app do the timing", body: "Cards you find hard come back soon and often; cards you know well come back less often — so you spend time where it matters." },
  { n: 5, title: "Watch your mastery grow", body: "Each topic has a mastery ring that fills up (grey → yellow → green) as you learn. The Progress page shows your weakest topics." },
  { n: 6, title: "Come back tomorrow", body: "Your progress saves automatically on any device. Cards that are due reappear on your dashboard — just keep showing up." },
];

export function HowItWorksDialog({ open, onOpenChange }) {
  const navigate = useNavigate();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="how-it-works-dialog">
        <DialogHeader>
          <img src="/science-sorted-logo.png" alt="Science Sorted" className="h-9 w-auto mb-1" />
          <DialogTitle className="font-display text-2xl">How your flashcards work</DialogTitle>
          <DialogDescription>A quick guide to getting the most out of your revision.</DialogDescription>
        </DialogHeader>
        <ol className="space-y-4 mt-1">
          {GUIDE_STEPS.map((s) => (
            <li key={s.n} className="flex gap-3">
              <span className="shrink-0 h-7 w-7 rounded-full bg-[#FFC200] text-[#141821] font-display font-bold flex items-center justify-center text-sm">{s.n}</span>
              <div>
                <div className="font-semibold text-slate-900">{s.title}</div>
                <p className="text-sm text-slate-600 mt-0.5">{s.body}</p>
              </div>
            </li>
          ))}
        </ol>
        <div className="rounded-lg bg-slate-900 text-white p-4 text-sm mt-1">
          <span className="font-semibold text-[#FFC200]">Golden rule:</span> answer honestly, come back every day, and let the app show you what you're about to forget — at exactly the right moment.
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => { onOpenChange(false); navigate("/flashcards/guide"); }} data-testid="open-print-guide">
            <Printer className="h-4 w-4 mr-2" /> Printable version
          </Button>
          <Button onClick={() => onOpenChange(false)} data-testid="close-how-it-works"
            className="bg-[#FFC200] text-[#141821] hover:bg-[#141821] hover:text-[#FFC200] font-semibold">
            Got it
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
